const padTwo = ( value: number ): string => `${ value }`.padStart( 2, '0' );

export const formatClock = ( ms: number ): string => {
    const totalSeconds = Math.floor( ms / 1000 );
    const hours = Math.floor( totalSeconds / 3600 );
    const minutes = Math.floor( ( totalSeconds % 3600 ) / 60 );
    const seconds = totalSeconds % 60;
    return `${ padTwo( hours ) }:${ padTwo( minutes ) }:${ padTwo( seconds ) }`;
};

export const formatDuration = ( ms: number ): string => {
    const totalMinutes = Math.floor( ms / 60000 );
    const hours = Math.floor( totalMinutes / 60 );
    const minutes = totalMinutes % 60;
    if( hours === 0 && minutes === 0 ) return '< 1m';
    if( hours === 0 ) return `${ minutes }m`;
    return `${ hours }h ${ padTwo( minutes ) }m`;
};

export const formatTimeOfDay = ( iso: string ): string =>
    new Date( iso ).toLocaleTimeString( undefined, { hour: 'numeric', minute: '2-digit' } );

// LoggedMinutes is the value stored on ConsultingClientOfferingHours.
// Any positive duration logs at least 1 minute.
export const durationMsToLoggedMinutes = ( ms: number ): number => {
    if( ms <= 0 ) return 0;
    return Math.max( 1, Math.round( ms / 60000 ) );
};

export const toLoggedMinutes = ( hours: number, minutes: number ): number =>
    hours * 60 + minutes;

export const splitLoggedMinutes = ( totalMinutes: number ): { hours: number; minutes: number } => {
    const safeMinutes = Math.max( 0, Math.trunc( totalMinutes ) );
    return {
        hours: Math.floor( safeMinutes / 60 ),
        minutes: safeMinutes % 60,
    };
};

export const formatLoggedMinutes = ( totalMinutes: number ): string => {
    const { hours, minutes } = splitLoggedMinutes( totalMinutes );
    if( hours === 0 ) return `${ minutes }m`;
    if( minutes === 0 ) return `${ hours }h`;
    return `${ hours }h ${ minutes }m`;
};

export const describeLoggedDuration = ( ms: number ): { hours: number; minutes: number; trackedLabel: string } => {
    const loggedMinutes = durationMsToLoggedMinutes( ms );
    const { hours, minutes } = splitLoggedMinutes( loggedMinutes );
    return {
        hours,
        minutes,
        trackedLabel: formatLoggedMinutes( loggedMinutes ),
    };
};

export const toLocalIsoDate = ( iso: string ): string => {
    const date = new Date( iso );
    return `${ date.getFullYear() }-${ padTwo( date.getMonth() + 1 ) }-${ padTwo( date.getDate() ) }`;
};
